/* eslint-disable react/no-string-refs, react/no-array-index-key, consistent-return, array-callback-return */
import React from 'react';
import Datetime from 'react-datetime';
import moment from 'moment';
import 'moment/locale/tr';
import { withNamespaces } from 'react-i18next';
import { trVisaOptions, enVisaOptions } from '../../../constants/visa-options';
import { enCountries } from '../../../constants/i18Util';

class AbroadArea extends React.Component {
  constructor(props) {
    super(props);

    this.changeWorkStartDate = this.changeWorkStartDate.bind(this);
    this.changeWorkStartHour = this.changeWorkStartHour.bind(this);
    this.changePassportNo = this.changePassportNo.bind(this);
    this.changeCountry = this.changeCountry.bind(this);
    this.changeRoadFriends = this.changeRoadFriends.bind(this);
    this.changeVisa = this.changeVisa.bind(this);
  }

  componentDidMount() {
    const countriesComponent = this.refs.countries;
    const options = countriesComponent.options;
    const { request,i18n } = this.props;
    moment.locale(i18n.language === 'en' ? 'en' : 'tr');

    Object.keys(countriesComponent.options).some((index) => {
      if (options[index].text === request.abroad.country) {
        countriesComponent.selectedIndex = parseInt(index);

        return true;
      }
    });
  }

  componentDidUpdate(prevProps) {
    const {i18n} = this.props;
    if (prevProps.i18n.language !== i18n.language) {
      moment.locale(i18n.language === 'en' ? 'en' : 'tr');
    }
  }

  changeWorkStartDate(momentDate) {
    const { request, changeRequest } = this.props;

    if (moment.isMoment(momentDate)) {
      changeRequest({
        ...request,
        abroad: {
          ...request.abroad,
          workStartDate: momentDate.unix() * 1000,
        },
      });
    }
  }

  changeWorkStartHour(momentDate) {
    const { request, changeRequest, hoursFormat } = this.props;

    changeRequest({
      ...request,
      abroad: { ...request.abroad, workStartHour: hoursFormat(momentDate) },
    });
  }

  changePassportNo(e) {
    const { request, changeRequest } = this.props;

    changeRequest(
      { ...request, abroad: { ...request.abroad, passportNo: e.target.value } });
  }

  changeCountry(e) {
    const { request, changeRequest } = this.props;
    const payload = {
      ...request,
      abroad: {
        ...request.abroad,
        country: e.target.selectedOptions[0].text,
        region: (e.target.value ? e.target.value : null),
      },
    };

    changeRequest(payload);
  }

  changeRoadFriends(e) {
    const { request, changeRequest } = this.props;

    changeRequest(
      { ...request, abroad: { ...request.abroad, roadFriends: e.target.value } });
  }

  changeVisa(e) {
    const { request, changeRequest } = this.props;

    changeRequest({
      ...request,
      abroad: {
        ...request.abroad,
        visa: (e.target.selectedIndex
          ? trVisaOptions[e.target.selectedIndex - 1]
          : null),
      },
    });
  }

  render() {
    const { request, countries, t } = this.props;

    return (
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label>
              <span className="required-field">
                *
              </span>
              {' '}
              {' '}
              {t('jobStartDate')}
            </label>
            <Datetime
              key={this.props.i18n.language}
              locale={this.props.i18n.language === 'en' ? 'en' : 'tr'}
              value={request.abroad && request.abroad.workStartDate}
              dateFormat="DD-MM-YYYY"
              timeFormat={false}
              onChange={this.changeWorkStartDate}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label>
              <span className="required-field">
                *
              </span>
              {' '}
              {t('jobStartTime')}
            </label>
            <Datetime
              key={this.props.i18n.language}
              locale={this.props.i18n.language === 'en' ? 'en' : 'tr'}
              value={request.abroad && request.abroad.workStartHour}
              dateFormat={false}
              timeFormat="HH:mm"
              onChange={this.changeWorkStartHour}
            />
          </div>
        </div>
        <div className="col-md-4">
          <div className="form-group">
            <label>
              <span className="required-field">
                *
              </span>
              {' '}
              {t('country')}
            </label>
            <select
              ref="countries"
              className="form-control border-input"
              onChange={this.changeCountry}
              id="country"
            >
              <option>
                {t('choose')}
              </option>
              { this.props.i18n.language === 'tr'
                ? countries.map((r, i) => (
                  <option key={i} value={r.region}>
                    {r.country}
                  </option>
                ))
                : enCountries().map((r, i) => (
                  <option key={i} value={r.region}>
                    {r.country}
                  </option>
                ))
              }
            </select>
          </div>
        </div>


        <div className="col-md-4">
          <div className="form-group">
            <label>
              { request.abroad.isPasaportRequired
                ? (
                  <span className="required-field">
                    *
                  </span>
                ) : null
                            }
              {' '}
              {t('passportNo')}
            </label>
            <input
              type="text"
              className="form-control border-input"
              value={request.abroad && request.abroad.passportNo}
              onChange={this.changePassportNo}
              placeholder={t('enterPassportNumber')}
              id="passportNo"
            />
          </div>
        </div>

        <div className="col-md-4">
          <div className="form-group">
            <label>
              { request.abroad.isPasaportRequired
                ? (
                  <span className="required-field">
                    *
                  </span>
                ) : null
                }
              {' '}
              {t('visaStatus')}
            </label>
            <select
              className="form-control border-input"
              value={request.abroad && request.abroad.visa ? request.abroad.visa.value : ''}
              onChange={this.changeVisa}
              id="visaStatus"
            >
              <option>
                {t('choose')}
              </option>
              {this.props.i18n.language === 'tr'
                ? trVisaOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))
                : enVisaOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))

              }
            </select>
          </div>
        </div>
        <div className="col-md-12">
          <div className="form-group">
            <label>
              <span className="required-field" />
              {' '}
              {t('peopleYouTravelWith')}
            </label>
            <div>
              <textarea
                id="peopleYouTravelWith"
                defaultValue={request.abroad && request.abroad.roadFriends}
                onChange={this.changeRoadFriends}
                className="custom-input"
              />
            </div>
          </div>
        </div>
        {}
      </div>
    );
  }
}

export default withNamespaces()(AbroadArea);



// WEBPACK FOOTER //
// ./src/components/abroad/area/index.js